// extracted by mini-css-extract-plugin
export var container = "motivation-section-module--container--qrztm";
export var backgroundImage = "motivation-section-module--background-image--SCq07";
export var inner = "motivation-section-module--inner--l1b9g";
export var paragraph = "motivation-section-module--paragraph--U9M4a";